import { useEffect, useMemo, useRef, useState } from "react";
import slideOne from "../img/1.webp";
import slideTwo from "../img/2.webp";
import slideThree from "../img/3.webp";
import slideFour from "../img/4.webp";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where
} from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

function ReservationPageAdm({ userEmail, onLogout, userRole }) {
  const PAGE_SIZE = 20;
  const slides = [slideOne, slideTwo, slideThree, slideFour];
  const [reservations, setReservations] = useState([]);
  const [reservationsLoading, setReservationsLoading] = useState(true);
  const [reservationsError, setReservationsError] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [calendarDate, setCalendarDate] = useState(() => new Date());
  const [calendarModalOpen, setCalendarModalOpen] = useState(false);
  const [modalShowCalendar, setModalShowCalendar] = useState(false);
  const [infoModal, setInfoModal] = useState({ open: false, message: "" });
  const [modalValues, setModalValues] = useState({
    guestName: "",
    guestEmail: "",
    guestPhone: "",
    checkIn: "",
    checkOut: "",
    roomAssignments: [],
    reservationItemIds: [],
    reservationItemsQty: {},
    paymentMethodId: "",
    paymentPaid: false,
    createdAt: null,
    notes: ""
  });
  const [modalStatus, setModalStatus] = useState({ type: "", message: "" });
  const [modalSaving, setModalSaving] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editId, setEditId] = useState("");
  const [editValues, setEditValues] = useState({
    guestName: "",
    guestEmail: "",
    guestPhone: "",
    checkIn: "",
    checkOut: "",
    roomAssignments: [],
    reservationItemIds: [],
    reservationItemsQty: {},
    paymentMethodId: "",
    paymentPaid: false,
    createdAt: null,
    notes: ""
  });
  const [editStatus, setEditStatus] = useState({ type: "", message: "" });
  const [editSaving, setEditSaving] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [priceListRooms, setPriceListRooms] = useState([]);
  const [reservationItems, setReservationItems] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const calendarWrapRef = useRef(null);
  const modalCalendarWrapRef = useRef(null);
  const ADMIN_NOTIFICATION_EMAIL = "odp.bartne@gmail.com";

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const resolveNotificationEmail = (value) => {
    const rawValue = String(value ?? "");
    const email = rawValue.trim();

    if (rawValue.length === 0) {
      return {
        email: ADMIN_NOTIFICATION_EMAIL,
        error: ""
      };
    }

    if (rawValue !== email || !isValidEmail(email)) {
      return {
        email: "",
        error: "Podaj poprawny adres e-mail albo zostaw pole puste."
      };
    }

    return {
      email,
      error: ""
    };
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(intervalId);
  }, [slides.length]);

  useEffect(() => {
    const reservationsQuery = query(
      collection(db, "reservations"),
      where("stayType", "==", "room")
    );

    const unsubscribe = onSnapshot(
      reservationsQuery,
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
        const sortedItems = items.sort((a, b) => {
          const aTime = a.createdAt?.toDate?.().getTime?.() || 0;
          const bTime = b.createdAt?.toDate?.().getTime?.() || 0;
          return bTime - aTime;
        });
        setReservations(sortedItems);
        setReservationsLoading(false);
        setReservationsError("");
      },
      (error) => {
        setReservationsLoading(false);
        setReservationsError(error.message || "Brak dostępu do rezerwacji.");
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "priceList"), (snapshot) => {
      const rooms = [];
      const reservations = [];
      const payments = [];
      snapshot.docs.forEach((docSnap) => {
        const data = docSnap.data();
        const type = data.type || (docSnap.id === "reservation" ? "reservation" : "room");
        if (type === "reservation") {
          reservations.push({ id: docSnap.id, ...data });
        } else if (type === "payment") {
          payments.push({ id: docSnap.id, ...data });
        } else {
          rooms.push({ id: docSnap.id, ...data });
        }
      });
      setPriceListRooms(rooms);
      setReservationItems(reservations);
      setPaymentMethods(payments);
    });

    return () => unsubscribe();
  }, []);

  const formatDate = (value) => {
    if (!value) {
      return "-";
    }

    if (typeof value === "string") {
      const date = new Date(value);
      if (!Number.isNaN(date.getTime())) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }

      return value;
    }

    if (value?.toDate) {
      const date = value.toDate();
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }

    return "-";
  };

  const getDueDateClass = (dueDate, paid) => {
    if (!dueDate) {
      return "";
    }
    if (paid) {
      return "PaymentDuePaid";
    }
    const parsed = normalizeDate(dueDate);
    if (!parsed) {
      return "";
    }
    const today = normalizeDate(new Date());
    if (!today) {
      return "";
    }
    return parsed >= today ? "PaymentDueUpcoming" : "PaymentDueOverdue";
  };

  const formatInputDate = (date) => {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const normalizeDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const daysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const addMonths = (date, amount) => {
    const next = new Date(date);
    next.setMonth(next.getMonth() + amount);
    return next;
  };

  const scrollCalendarToToday = (container) => {
    if (!container) {
      return;
    }
    const todayCell = container.querySelector("th[data-today='true']");
    if (!todayCell) {
      return;
    }
    const dayWidth = todayCell.clientWidth || 0;
    const targetLeft = todayCell.offsetLeft
      + dayWidth * 1
      - container.clientWidth / 2
      + todayCell.clientWidth / 2;
    container.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
  };

  const calendarDays = useMemo(() => {
    const totalDays = daysInMonth(calendarDate);
    const days = [];
    for (let day = 1; day <= totalDays; day += 1) {
      days.push(new Date(calendarDate.getFullYear(), calendarDate.getMonth(), day));
    }
    return days;
  }, [calendarDate]);

  useEffect(() => {
    const today = new Date();
    const isCurrentMonth =
      today.getFullYear() === calendarDate.getFullYear()
      && today.getMonth() === calendarDate.getMonth();
    if (!isCurrentMonth) {
      return;
    }
    requestAnimationFrame(() => {
      scrollCalendarToToday(calendarWrapRef.current);
      if (modalShowCalendar) {
        scrollCalendarToToday(modalCalendarWrapRef.current);
      }
    });
  }, [calendarDate, calendarDays, modalShowCalendar]);

  const priceListRoomNames = useMemo(
    () => priceListRooms.map((room) => String(room.name).trim()).filter(Boolean),
    [priceListRooms]
  );
  const allRoomNumbers = priceListRoomNames;

  const occupancyByRoom = useMemo(() => {
    const occupancy = {};
    allRoomNumbers.forEach((room) => {
      const key = String(room).trim();
      if (!key) {
        return;
      }
      occupancy[key] = {};
      calendarDays.forEach((day) => {
        const dayKey = day.getDate();
        occupancy[key][dayKey] = 0;
      });
    });

    reservations.forEach((reservation) => {
      if (reservation.stayType !== "room") {
        return;
      }

      const checkIn = normalizeDate(reservation.checkIn);
      const checkOut = normalizeDate(reservation.checkOut);
      if (!checkIn || !checkOut) {
        return;
      }

      const assignments = Array.isArray(reservation.roomAssignments)
        ? reservation.roomAssignments
        : [
            {
              roomNumber: reservation.roomNumber,
              guestsCount: reservation.guestsCount
            }
          ];

      assignments.forEach((assignment) => {
        const room = String(assignment.roomNumber || "").trim();
        if (!room || !occupancy[room]) {
          return;
        }
        const guests = Number(assignment.guestsCount) || 0;

        calendarDays.forEach((day) => {
          if (day >= checkIn && day < checkOut) {
            const dayKey = day.getDate();
            occupancy[room][dayKey] += guests;
          }
        });
      });
    });

    return occupancy;
  }, [allRoomNumbers, calendarDays, reservations]);

  const filteredReservations = reservations.filter((item) => {
    if (!searchText) {
      return true;
    }

    const text = searchText.toLowerCase();
    return [
      item.guestName,
      item.guestEmail,
      item.guestPhone
    ]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(text));
  });

  const totalPages = Math.max(1, Math.ceil(filteredReservations.length / PAGE_SIZE));
  const safePage = Math.min(currentPage, totalPages);
  const paginatedReservations = filteredReservations.slice(
    (safePage - 1) * PAGE_SIZE,
    safePage * PAGE_SIZE
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    if (currentPage !== safePage) {
      setCurrentPage(safePage);
    }
  }, [currentPage, safePage]);

  const getRoomCapacityByNumber = (roomNumber) => {
    const roomKey = String(roomNumber || "").trim();
    const priceListRoom = priceListRooms.find(
      (room) => String(room.name).trim() === roomKey
    );
    if (priceListRoom?.personLimit) {
      const limit = Number(priceListRoom.personLimit);
      return Number.isFinite(limit) && limit > 0 ? limit : 1;
    }
    return 1;
  };

  const getTotalGuests = (assignments) =>
    assignments.reduce(
      (sum, assignment) => sum + (Number(assignment.guestsCount) || 0),
      0
    );

  const roomPricingByName = useMemo(() => {
    const map = new Map();
    priceListRooms.forEach((item) => {
      if (item?.name) {
        map.set(String(item.name).trim(), item);
      }
    });
    return map;
  }, [priceListRooms]);

  const reservationItemsById = useMemo(() => {
    const map = new Map();
    reservationItems.forEach((item) => {
      if (item?.id) {
        map.set(item.id, item);
      }
    });
    return map;
  }, [reservationItems]);

  const paymentMethodsById = useMemo(() => {
    const map = new Map();
    paymentMethods.forEach((item) => {
      if (item?.id) {
        map.set(item.id, item);
      }
    });
    return map;
  }, [paymentMethods]);

  const defaultPaymentMethodId = useMemo(() => {
    const defaultMethod = paymentMethods.find((method) => method.isDefault);
    return defaultMethod?.id || "";
  }, [paymentMethods]);

  const getReservationItemRules = (item) => {
    const price = Number(item?.price);
    const fallbackPerDay = Number(item?.pricePerReservation);
    const fallbackPerPerson = Number(item?.pricePerPerson);
    const applyPerDay = typeof item?.applyPerDay === "boolean"
      ? item.applyPerDay
      : Number.isFinite(fallbackPerDay) && fallbackPerDay > 0;
    const applyPerPerson = typeof item?.applyPerPerson === "boolean"
      ? item.applyPerPerson
      : Number.isFinite(fallbackPerPerson) && fallbackPerPerson > 0;
    const resolvedPrice = Number.isFinite(price)
      ? price
      : Number.isFinite(fallbackPerDay)
        ? fallbackPerDay
        : Number.isFinite(fallbackPerPerson)
          ? fallbackPerPerson
          : 0;

    return {
      price: resolvedPrice,
      applyPerDay,
      applyPerPerson
    };
  };

  const getRoomPricing = (assignment) => {
    const roomNumberKey = String(assignment.roomNumber || "").trim();
    const pricing = roomPricingByName.get(roomNumberKey)
      || null;
    const parsedPrice = Number(pricing?.price);
    const parsedPerDay = Number(pricing?.pricePerDay);
    const parsedPerPerson = Number(pricing?.pricePerPerson);
    const applyPerPerson = typeof pricing?.applyPerPerson === "boolean"
      ? pricing.applyPerPerson
      : Number.isFinite(parsedPerPerson) && parsedPerPerson > 0;
    const resolvedPerDay = Number.isFinite(parsedPrice)
      ? parsedPrice
      : Number.isFinite(parsedPerDay)
        ? parsedPerDay
        : 0;
    const resolvedPerPerson = Number.isFinite(parsedPrice)
      ? (applyPerPerson ? parsedPrice : 0)
      : Number.isFinite(parsedPerPerson)
        ? parsedPerPerson
        : 0;

    return {
      pricePerDay: resolvedPerDay,
      pricePerPerson: resolvedPerPerson,
      applyPerPerson
    };
  };

  const getBaseRoomCost = (assignments, checkIn, checkOut) => {
    const nights = getNights(checkIn, checkOut);
    return assignments.reduce((sum, assignment) => {
      const guests = Number(assignment.guestsCount) || 0;
      const pricing = getRoomPricing(assignment);
      if (pricing.applyPerPerson) {
        return sum + pricing.pricePerPerson * guests * nights;
      }
      return sum + pricing.pricePerDay * nights;
    }, 0);
  };

  const getReservationItemsCost = (reservationItemIds, reservationItemsQty, guests, nights) => {
    if (!Array.isArray(reservationItemIds) || reservationItemIds.length === 0) {
      return 0;
    }

    return reservationItemIds.reduce((sum, itemId) => {
      const item = reservationItemsById.get(itemId);
      if (!item) {
        return sum;
      }
      const rules = getReservationItemRules(item);
      const qty = Number(reservationItemsQty?.[itemId]) || 0;
      if (qty < 1) {
        return sum;
      }
      const perDayCost = rules.applyPerDay && rules.price > 0
        ? rules.price * nights * qty
        : 0;
      const perPersonCost = rules.applyPerPerson && rules.price > 0
        ? rules.price * guests * qty
        : 0;
      const flatCost = !rules.applyPerDay && !rules.applyPerPerson && rules.price > 0
        ? rules.price * qty
        : 0;
      return sum + perDayCost + perPersonCost + flatCost;
    }, 0);
  };

  const getReservationItemsSnapshot = (reservationItemIds, reservationItemsQty) => {
    if (!Array.isArray(reservationItemIds)) {
      return [];
    }
    return reservationItemIds
      .map((itemId) => {
        const item = reservationItemsById.get(itemId);
        if (!item) {
          return null;
        }
        const quantity = Number(reservationItemsQty?.[itemId]) || 0;
        if (quantity < 1) {
          return null;
        }
        return {
          id: item.id,
          name: item.name,
          quantity,
          price: getReservationItemRules(item).price,
          applyPerDay: getReservationItemRules(item).applyPerDay,
          applyPerPerson: getReservationItemRules(item).applyPerPerson
        };
      })
      .filter(Boolean);
  };

  const getReservationItemsLabel = (reservation) => {
    const snapshotItems = Array.isArray(reservation?.reservationItems)
      ? reservation.reservationItems
      : [];

    if (snapshotItems.length > 0) {
      return snapshotItems
        .map((item) => {
          const name = String(item?.name || "").trim();
          if (!name) {
            return null;
          }
          const price = Number(item?.price);
          const qty = Number(item?.quantity);
          const qtyLabel = Number.isFinite(qty) && qty > 0 ? ` x${qty}` : "";
          const priceLabel = Number.isFinite(price) ? `${price} PLN` : "-";
          return `${name}${qtyLabel} (${priceLabel})`;
        })
        .filter(Boolean)
        .join(", ");
    }

    if (Array.isArray(reservation?.reservationItemIds)) {
      return reservation.reservationItemIds
        .map((itemId) => {
          const item = reservationItemsById.get(itemId);
          if (!item?.name) {
            return null;
          }
          const price = Number(item.price);
          const priceLabel = Number.isFinite(price) ? `${price} PLN` : "-";
          return `${item.name} (${priceLabel})`;
        })
        .filter(Boolean)
        .join(", ");
    }

    return "";
  };

  const getTotalPrice = (assignments, checkIn, checkOut, reservationItemIds, reservationItemsQty) => {
    const baseCost = getBaseRoomCost(assignments, checkIn, checkOut);
    const totalGuests = getTotalGuests(assignments);
    const nights = getNights(checkIn, checkOut);
    const extrasCost = getReservationItemsCost(
      reservationItemIds,
      reservationItemsQty,
      totalGuests,
      nights
    );
    return baseCost + extrasCost;
  };

  const addWorkingDays = (value, daysToAdd) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    let added = 0;
    const next = new Date(date);
    while (added < daysToAdd) {
      next.setDate(next.getDate() + 1);
      const day = next.getDay();
      if (day !== 0 && day !== 6) {
        added += 1;
      }
    }
    return next;
  };

  const getDepositInfo = (totalPrice, purchaseDate, paymentMethodId) => {
    if (!paymentMethodId) {
      return { amount: 0, dueDate: "" };
    }
    const method = paymentMethodsById.get(paymentMethodId);
    if (!method) {
      return { amount: 0, dueDate: "" };
    }
    const percent = Number(method.depositPercent) || 0;
    const amount = Math.round(totalPrice * (percent / 100) * 100) / 100;
    if (!purchaseDate) {
      return { amount, dueDate: "" };
    }
    const dueDate = addWorkingDays(purchaseDate, 3);
    if (!dueDate) {
      return { amount, dueDate: "" };
    }
    return { amount, dueDate: formatInputDate(dueDate) };
  };

  const isOverlapping = (startA, endA, startB, endB) => {
    const aStart = new Date(startA).getTime();
    const aEnd = new Date(endA).getTime();
    const bStart = new Date(startB).getTime();
    const bEnd = new Date(endB).getTime();

    if (!aStart || !aEnd || !bStart || !bEnd) {
      return false;
    }

    return aStart < bEnd && aEnd > bStart;
  };

  const getNights = (start, end) => {
    if (!start || !end) {
      return 0;
    }
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate.getTime() - startDate.getTime();
    if (Number.isNaN(diffMs) || diffMs <= 0) {
      return 0;
    }
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    if (!calendarModalOpen) {
      return;
    }
    if (modalValues.paymentMethodId || !defaultPaymentMethodId) {
      return;
    }
    setModalValues((prev) => ({
      ...prev,
      paymentMethodId: defaultPaymentMethodId
    }));
  }, [calendarModalOpen, modalValues.paymentMethodId, defaultPaymentMethodId]);

  const handleCalendarOpen = (roomNumber, day) => {
    const capacity = getRoomCapacityByNumber(roomNumber);
    const dayKey = day.getDate();
    const occupied = occupancyByRoom[roomNumber]?.[dayKey] || 0;

    if (occupied >= capacity) {
      setInfoModal({ open: true, message: "Nie ma miejsc w pokoju." });
      setCalendarModalOpen(false);
      return;
    }

    setCalendarModalOpen(true);
    setModalShowCalendar(false);
    setModalStatus({ type: "", message: "" });
    setModalValues({
      guestName: "",
      guestEmail: "",
      guestPhone: "",
      checkIn: formatInputDate(day),
      checkOut: "",
      roomAssignments: [
        {
          roomNumber,
          guestsCount: 1
        }
      ],
      reservationItemIds: [],
      reservationItemsQty: {},
      paymentMethodId: defaultPaymentMethodId,
      createdAt: new Date(),
      notes: ""
    });
  };

  const updateModalAssignment = (index, updates) => {
    setModalValues((prev) => {
      const nextAssignments = prev.roomAssignments.map((assignment, idx) =>
        idx === index ? { ...assignment, ...updates } : assignment
      );
      return {
        ...prev,
        roomAssignments: nextAssignments
      };
    });
  };

  const getFullCapacityAssignments = () =>
    allRoomNumbers.map((roomNumber) => ({
      roomNumber,
      guestsCount: getRoomCapacityByNumber(roomNumber)
    }));

  const addModalRoom = () => {
    setModalShowCalendar(true);
    setModalValues((prev) => {
      const usedRooms = prev.roomAssignments.map((assignment) => assignment.roomNumber);
      const nextRoom = allRoomNumbers.find((room) => !usedRooms.includes(room)) || "";
      return {
        ...prev,
        roomAssignments: [
          ...prev.roomAssignments,
          { roomNumber: nextRoom, guestsCount: 1 }
        ]
      };
    });
  };

  const reserveAllModalRooms = () => {
    setModalShowCalendar(true);
    setModalValues((prev) => ({
      ...prev,
      roomAssignments: getFullCapacityAssignments()
    }));
  };

  const toggleModalReservationItem = (itemId) => {
    setModalValues((prev) => {
      const current = new Set(prev.reservationItemIds || []);
      if (current.has(itemId)) {
        current.delete(itemId);
      } else {
        current.add(itemId);
      }
      return {
        ...prev,
        reservationItemIds: Array.from(current),
        reservationItemsQty: current.has(itemId)
          ? prev.reservationItemsQty || {}
          : Object.fromEntries(
              Object.entries(prev.reservationItemsQty || {}).filter(([key]) => key !== itemId)
            )
      };
    });
  };

  const updateModalReservationItemQty = (itemId, value) => {
    setModalValues((prev) => {
      const nextQty = { ...(prev.reservationItemsQty || {}) };
      const parsedQty = Number(value);
      const hasPositiveQty = Number.isFinite(parsedQty) && parsedQty > 0;
      const current = new Set(prev.reservationItemIds || []);

      if (hasPositiveQty) {
        nextQty[itemId] = value;
        current.add(itemId);
      } else {
        delete nextQty[itemId];
        current.delete(itemId);
      }

      return {
        ...prev,
        reservationItemIds: Array.from(current),
        reservationItemsQty: nextQty
      };
    });
  };

  const removeModalRoom = (index) => {
    setModalValues((prev) => {
      if (prev.roomAssignments.length <= 1) {
        return prev;
      }
      return {
        ...prev,
        roomAssignments: prev.roomAssignments.filter((_, idx) => idx !== index)
      };
    });
  };

  const handleEditOpen = (reservation) => {
    const assignments = Array.isArray(reservation.roomAssignments)
      ? reservation.roomAssignments
      : [
          {
            roomNumber: reservation.roomNumber || "",
            guestsCount: reservation.guestsCount || 1
          }
        ];
    const createdAt = reservation.createdAt?.toDate
      ? reservation.createdAt.toDate()
      : reservation.createdAt || null;
    setEditId(reservation.id);
    setEditStatus({ type: "", message: "" });
    setEditValues({
      guestName: reservation.guestName || "",
      guestEmail: reservation.guestEmail || "",
      guestPhone: reservation.guestPhone || "",
      checkIn: reservation.checkIn || "",
      checkOut: reservation.checkOut || "",
      roomAssignments: assignments,
      reservationItemIds: Array.isArray(reservation.reservationItemIds)
        ? reservation.reservationItemIds
        : [],
      reservationItemsQty: Array.isArray(reservation.reservationItems)
        ? reservation.reservationItems.reduce((acc, item) => {
            if (item?.id) {
              acc[item.id] = item.quantity || 1;
            }
            return acc;
          }, {})
        : {},
      paymentMethodId: reservation.paymentMethodId || "",
      paymentPaid: Boolean(reservation.paymentPaid),
      createdAt,
      notes: reservation.notes || reservation.note || ""
    });
    setEditModalOpen(true);
  };

  const updateEditAssignment = (index, updates) => {
    setEditValues((prev) => {
      const nextAssignments = prev.roomAssignments.map((assignment, idx) =>
        idx === index ? { ...assignment, ...updates } : assignment
      );
      return {
        ...prev,
        roomAssignments: nextAssignments
      };
    });
  };

  const addEditRoom = () => {
    setEditValues((prev) => {
      const usedRooms = prev.roomAssignments.map((assignment) => assignment.roomNumber);
      const nextRoom = allRoomNumbers.find((room) => !usedRooms.includes(room)) || "";
      return {
        ...prev,
        roomAssignments: [
          ...prev.roomAssignments,
          { roomNumber: nextRoom, guestsCount: 1 }
        ]
      };
    });
  };

  const reserveAllEditRooms = () => {
    setEditValues((prev) => ({
      ...prev,
      roomAssignments: getFullCapacityAssignments()
    }));
  };

  const toggleEditReservationItem = (itemId) => {
    setEditValues((prev) => {
      const current = new Set(prev.reservationItemIds || []);
      if (current.has(itemId)) {
        current.delete(itemId);
      } else {
        current.add(itemId);
      }
      return {
        ...prev,
        reservationItemIds: Array.from(current),
        reservationItemsQty: current.has(itemId)
          ? prev.reservationItemsQty || {}
          : Object.fromEntries(
              Object.entries(prev.reservationItemsQty || {}).filter(([key]) => key !== itemId)
            )
      };
    });
  };

  const updateEditReservationItemQty = (itemId, value) => {
    setEditValues((prev) => ({
      ...prev,
      reservationItemsQty: {
        ...(prev.reservationItemsQty || {}),
        [itemId]: value
      }
    }));
  };

  const removeEditRoom = (index) => {
    setEditValues((prev) => {
      if (prev.roomAssignments.length <= 1) {
        return prev;
      }
      return {
        ...prev,
        roomAssignments: prev.roomAssignments.filter((_, idx) => idx !== index)
      };
    });
  };

  const handleCalendarSubmit = async (event) => {
    event.preventDefault();
    setModalStatus({ type: "", message: "" });
    setModalSaving(true);
    const guestEmail = String(modalValues.guestEmail ?? "");
    const notificationEmail = resolveNotificationEmail(guestEmail);

    if (notificationEmail.error) {
      setModalStatus({ type: "error", message: notificationEmail.error });
      setModalSaving(false);
      return;
    }

    try {
      if (!modalValues.checkIn || !modalValues.checkOut) {
        setModalStatus({ type: "error", message: "Wybierz daty pobytu." });
        setModalSaving(false);
        return;
      }

      if (new Date(modalValues.checkIn) >= new Date(modalValues.checkOut)) {
        setModalStatus({
          type: "error",
          message: "Data wymeldowania musi być później niż zameldowanie."
        });
        setModalSaving(false);
        return;
      }

      const selectedRooms = modalValues.roomAssignments
        .map((assignment) => assignment.roomNumber)
        .filter(Boolean);
      if (selectedRooms.length !== new Set(selectedRooms).size) {
        setModalStatus({
          type: "error",
          message: "Ten sam pokój nie może być dodany dwa razy."
        });
        setModalSaving(false);
        return;
      }

      const getGuestsForRoom = (data, roomNumber) => {
        if (Array.isArray(data.roomAssignments)) {
          const match = data.roomAssignments.find(
            (assignment) => assignment.roomNumber === roomNumber
          );
          return Number(match?.guestsCount) || 0;
        }

        if (data.roomNumber === roomNumber) {
          return Number(data.guestsCount) || 0;
        }

        return 0;
      };

      for (const assignment of modalValues.roomAssignments) {
        const capacity = getRoomCapacityByNumber(assignment.roomNumber);
        const requestedGuests = Number(assignment.guestsCount) || 0;

        if (!assignment.roomNumber) {
          setModalStatus({
            type: "error",
            message: "Wybierz numer pokoju dla każdej rezerwacji."
          });
          setModalSaving(false);
          return;
        }

        if (requestedGuests > capacity) {
          setModalStatus({
            type: "error",
            message: `Pokój ${assignment.roomNumber} ma maksymalnie ${capacity} miejsc.`
          });
          setModalSaving(false);
          return;
        }

        const roomQuery = query(
          collection(db, "reservations"),
          where("stayType", "==", "room"),
          where("roomNumber", "==", assignment.roomNumber)
        );
        const roomSnapshot = await getDocs(roomQuery);
        const overlappingGuests = roomSnapshot.docs.reduce((total, doc) => {
          const data = doc.data();
          if (
            isOverlapping(
              modalValues.checkIn,
              modalValues.checkOut,
              data.checkIn,
              data.checkOut
            )
          ) {
            return total + getGuestsForRoom(data, assignment.roomNumber);
          }

          return total;
        }, 0);

        if (overlappingGuests + requestedGuests > capacity) {
          setModalStatus({
            type: "error",
            message: `Brak wolnych miejsc w pokoju ${assignment.roomNumber} w wybranym terminie.`
          });
          setModalSaving(false);
          return;
        }
      }

      const totalGuestsInModal = getTotalGuests(modalValues.roomAssignments);
      const totalPrice = getTotalPrice(
        modalValues.roomAssignments,
        modalValues.checkIn,
        modalValues.checkOut,
        modalValues.reservationItemIds,
        modalValues.reservationItemsQty
      );
      const primaryPricing = getRoomPricing(modalValues.roomAssignments[0] || {});
      const reservationItemsSnapshot = getReservationItemsSnapshot(
        modalValues.reservationItemIds,
        modalValues.reservationItemsQty
      );
      const depositInfo = getDepositInfo(
        totalPrice,
        modalValues.createdAt || new Date(),
        modalValues.paymentMethodId
      );

      const reservationRef = await addDoc(collection(db, "reservations"), {
        guestName: modalValues.guestName,
        guestEmail,
        guestPhone: modalValues.guestPhone,
        checkIn: modalValues.checkIn,
        checkOut: modalValues.checkOut,
        roomAssignments: modalValues.roomAssignments,
        guestsCount: totalGuestsInModal,
        roomNumber: modalValues.roomAssignments[0]?.roomNumber || "",
        stayType: "room",
        pricePerPersonPln: primaryPricing.pricePerPerson,
        totalPricePln: totalPrice,
        reservationItemIds: modalValues.reservationItemIds,
        reservationItems: reservationItemsSnapshot,
        paymentMethodId: modalValues.paymentMethodId,
        depositAmountPln: depositInfo.amount,
        depositDueDate: depositInfo.dueDate,
        paymentPaid: false,
        confirmationToken: "",
        confirmationLink: "",
        confirmationConfirmed: false,
        confirmationConfirmedAt: "",
        notes: modalValues.notes,
        adminEmail: userEmail,
        createdAt: serverTimestamp()
      });
      await updateDoc(doc(db, "reservations", reservationRef.id), {
        reservationId: reservationRef.id
      });

      // Send webhook to n8n (same flow as client reservation)
      try {
        //await fetch("https://jquery.7776.link/webhook/d325ae95-ef69-49d7-8499-fc0e7271f268", {
          // await fetch("https://jquery.7776.link/webhook-test/adbe4626-af87-429c-b382-2b47a02517f3", {
            await fetch("https://jquery.7776.link/webhook/confirmation-email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            reservationId: reservationRef.id,
            guestName: modalValues.guestName,
            guestPhone: modalValues.guestPhone,
            guestEmail,
            recipientEmail: notificationEmail.email,
            checkIn: modalValues.checkIn,
            checkOut: modalValues.checkOut,
            roomGroupName: "",
            roomNumber: modalValues.roomAssignments[0]?.roomNumber || "",
            roomAssignments: modalValues.roomAssignments,
            guestsCount: totalGuestsInModal,
            paymentMethodId: modalValues.paymentMethodId,
            paymentMethodName: paymentMethodsById.get(modalValues.paymentMethodId)?.name || "",
            reservationItems: reservationItemsSnapshot.map((item) => ({
              name: item.name,
              quantity: Number(item.quantity) || 0
            })),
            notes: modalValues.notes || "",
            depositAmount: depositInfo.amount,
            depositDueDate: depositInfo.dueDate,
            totalPricePln: totalPrice
          })
        });
      } catch (webhookError) {
        // Do not block reservation creation if webhook fails.
      }

      setCalendarModalOpen(false);
    } catch (error) {
      setModalStatus({
        type: "error",
        message: error.message || "Nie udało się zapisać rezerwacji."
      });
    } finally {
      setModalSaving(false);
    }
  };

  const handleEditSubmit = async (event) => {
    event.preventDefault();
    setEditStatus({ type: "", message: "" });
    setEditSaving(true);
    const guestEmail = String(editValues.guestEmail ?? "");
    const notificationEmail = resolveNotificationEmail(guestEmail);

    if (notificationEmail.error) {
      setEditStatus({ type: "error", message: notificationEmail.error });
      setEditSaving(false);
      return;
    }

    try {
      if (!editValues.checkIn || !editValues.checkOut) {
        setEditStatus({ type: "error", message: "Wybierz daty pobytu." });
        setEditSaving(false);
        return;
      }

      if (new Date(editValues.checkIn) >= new Date(editValues.checkOut)) {
        setEditStatus({
          type: "error",
          message: "Data wymeldowania musi być później niż zameldowanie."
        });
        setEditSaving(false);
        return;
      }

      const selectedRooms = editValues.roomAssignments
        .map((assignment) => assignment.roomNumber)
        .filter(Boolean);
      if (selectedRooms.length !== new Set(selectedRooms).size) {
        setEditStatus({
          type: "error",
          message: "Ten sam pokój nie może być dodany dwa razy."
        });
        setEditSaving(false);
        return;
      }

      const getGuestsForRoom = (data, roomNumber) => {
        if (Array.isArray(data.roomAssignments)) {
          const match = data.roomAssignments.find(
            (assignment) => assignment.roomNumber === roomNumber
          );
          return Number(match?.guestsCount) || 0;
        }

        if (data.roomNumber === roomNumber) {
          return Number(data.guestsCount) || 0;
        }

        return 0;
      };

      for (const assignment of editValues.roomAssignments) {
        const capacity = getRoomCapacityByNumber(assignment.roomNumber);
        const requestedGuests = Number(assignment.guestsCount) || 0;

        if (!assignment.roomNumber) {
          setEditStatus({
            type: "error",
            message: "Wybierz numer pokoju dla każdej rezerwacji."
          });
          setEditSaving(false);
          return;
        }

        if (requestedGuests > capacity) {
          setEditStatus({
            type: "error",
            message: `Pokój ${assignment.roomNumber} ma maksymalnie ${capacity} miejsc.`
          });
          setEditSaving(false);
          return;
        }

        const roomQuery = query(
          collection(db, "reservations"),
          where("stayType", "==", "room"),
          where("roomNumber", "==", assignment.roomNumber)
        );
        const roomSnapshot = await getDocs(roomQuery);
        const overlappingGuests = roomSnapshot.docs.reduce((total, doc) => {
          if (doc.id === editId) {
            return total;
          }
          const data = doc.data();
          if (
            isOverlapping(
              editValues.checkIn,
              editValues.checkOut,
              data.checkIn,
              data.checkOut
            )
          ) {
            return total + getGuestsForRoom(data, assignment.roomNumber);
          }

          return total;
        }, 0);

        if (overlappingGuests + requestedGuests > capacity) {
          setEditStatus({
            type: "error",
            message: `Brak wolnych miejsc w pokoju ${assignment.roomNumber} w wybranym terminie.`
          });
          setEditSaving(false);
          return;
        }
      }

      const totalGuests = getTotalGuests(editValues.roomAssignments);
      const totalPrice = getTotalPrice(
        editValues.roomAssignments,
        editValues.checkIn,
        editValues.checkOut,
        editValues.reservationItemIds,
        editValues.reservationItemsQty
      );
      const primaryPricing = getRoomPricing(editValues.roomAssignments[0] || {});
      const reservationItemsSnapshot = getReservationItemsSnapshot(
        editValues.reservationItemIds,
        editValues.reservationItemsQty
      );
      const depositInfo = getDepositInfo(
        totalPrice,
        editValues.createdAt || new Date(),
        editValues.paymentMethodId
      );

      await updateDoc(doc(db, "reservations", editId), {
        guestName: editValues.guestName,
        guestEmail,
        guestPhone: editValues.guestPhone,
        checkIn: editValues.checkIn,
        checkOut: editValues.checkOut,
        roomAssignments: editValues.roomAssignments,
        guestsCount: totalGuests,
        roomNumber: editValues.roomAssignments[0]?.roomNumber || "",
        pricePerPersonPln: primaryPricing.pricePerPerson,
        totalPricePln: totalPrice,
        reservationItemIds: editValues.reservationItemIds,
        reservationItems: reservationItemsSnapshot,
        paymentMethodId: editValues.paymentMethodId,
        depositAmountPln: depositInfo.amount,
        depositDueDate: depositInfo.dueDate,
        paymentPaid: Boolean(editValues.paymentPaid),
        notes: editValues.notes
      });

      // Send webhook to n8n after admin edits reservation.
      try {
        // await fetch("https://jquery.7776.link/webhook/d325ae95-ef69-49d7-8499-fc0e7271f268", {
          // await fetch("https://jquery.7776.link/webhook-test/adbe4626-af87-429c-b382-2b47a02517f3", {
            await fetch("https://jquery.7776.link/webhook/confirmation-email", {
          
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            reservationId: editId,
            guestName: editValues.guestName,
            guestPhone: editValues.guestPhone,
            guestEmail,
            recipientEmail: notificationEmail.email,
            checkIn: editValues.checkIn,
            checkOut: editValues.checkOut,
            roomGroupName: "",
            roomNumber: editValues.roomAssignments[0]?.roomNumber || "",
            roomAssignments: editValues.roomAssignments,
            guestsCount: totalGuests,
            paymentMethodId: editValues.paymentMethodId,
            paymentMethodName: paymentMethodsById.get(editValues.paymentMethodId)?.name || "",
            reservationItems: reservationItemsSnapshot.map((item) => ({
              name: item.name,
              quantity: Number(item.quantity) || 0
            })),
            notes: editValues.notes || "",
            depositAmount: depositInfo.amount,
            depositDueDate: depositInfo.dueDate,
            totalPricePln: totalPrice
          })
        });
      } catch (webhookError) {
        // Do not block reservation update if webhook fails.
      }

      setEditModalOpen(false);
    } catch (error) {
      setEditStatus({
        type: "error",
        message: error.message || "Nie udało się zapisać zmian."
      });
    } finally {
      setEditSaving(false);
    }
  };

  const handleDelete = async (reservationId) => {
    try {
      await deleteDoc(doc(db, "reservations", reservationId));
    } catch (error) {
      setReservationsError(error.message || "Nie udało się usunąć rezerwacji.");
    }
  };

  const handlePaymentPaidToggle = async (reservationId, checked) => {
    try {
      await updateDoc(doc(db, "reservations", reservationId), {
        paymentPaid: checked
      });
    } catch (error) {
      setReservationsError(error.message || "Nie udało się zapisać płatności.");
    }
  };

  const goToPrevSlide = () => {
    setSlideIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNextSlide = () => {
    setSlideIndex((prev) => (prev + 1) % slides.length);
  };

  return (
    <div className="HomeShell">
      <Navbar menuItems={menuItems} onLogout={onLogout} userRole={userRole} />

      <section className="Slider">
        <div className="SliderTrack Manual">
          {slides.map((slide, index) => (
            <img
              key={slide}
              className={`Slide ${index === slideIndex ? "Active" : ""}`}
              src={slide}
              alt={`Schronisko slajd ${index + 1}`}
            />
          ))}
        </div>
        <button
          className="SliderArrow Left"
          type="button"
          onClick={goToPrevSlide}
          aria-label="Poprzednie zdjęcie"
        >
          &lt;
        </button>
        <button
          className="SliderArrow Right"
          type="button"
          onClick={goToNextSlide}
          aria-label="Następne zdjęcie"
        >
          &gt;
        </button>
        <div className="SliderCat" aria-hidden="true">
          <svg
            viewBox="0 0 18 18"
            role="presentation"
            focusable="false"
          >
            <path
              d="M 5 15 C 4.6667 14.3333 4 14 4 13 C 4 12 6 11 6 10 C 6 9 6 8 5 8 C 2 8 4 7 5 7 C 6 7 7 8 7 10 C 7 11 5 12 5 13 C 5 15 6 15 8 15 C 8 12 8 8 12 5 C 11.3333 4.6667 10 5 9 4 C 9 3 10 2 11 2 L 11 1 C 13 3 14 5 14 7 C 14 9 14 11 13 13 L 12 15 C 13 15 13 15 13 16 L 7 16 C 6 16 6 16 5 15"
            />
          </svg>
        </div>
        <div className="SliderCat SliderCatSecondary" aria-hidden="true">
          <svg
            viewBox="0 0 18 18"
            role="presentation"
            focusable="false"
          >
            <path
              d="M 5 15 C 4.6667 14.3333 4 14 4 13 C 4 12 6 11 6 10 C 6 9 6 8 5 8 C 2 8 4 7 5 7 C 6 7 7 8 7 10 C 7 11 5 12 5 13 C 5 15 6 15 8 15 C 8 12 8 8 12 5 C 11.3333 4.6667 10 5 9 4 C 9 3 10 2 11 2 L 11 1 C 13 3 14 5 14 7 C 14 9 14 11 13 13 L 12 15 C 13 15 13 15 13 16 L 7 16 C 6 16 6 16 5 15"
            />
          </svg>
        </div>
        <div className="SliderCat SliderCatTertiary" aria-hidden="true">
          <svg
            viewBox="0 0 18 18"
            role="presentation"
            focusable="false"
          >
            <path
              d="M 5 15 C 4.6667 14.3333 4 14 4 13 C 4 12 6 11 6 10 C 6 9 6 8 5 8 C 2 8 4 7 5 7 C 6 7 7 8 7 10 C 7 11 5 12 5 13 C 5 15 6 15 8 15 C 8 12 8 8 12 5 C 11.3333 4.6667 10 5 9 4 C 9 3 10 2 11 2 L 11 1 C 13 3 14 5 14 7 C 14 9 14 11 13 13 L 12 15 C 13 15 13 15 13 16 L 7 16 C 6 16 6 16 5 15"
            />
          </svg>
        </div>
      </section>

      <div className="WelcomePanel">
        <p className="Subtitle">Zalogowano jako {userEmail}.</p>
        <div className="BookingSection">
          <div className="TableSection">
            <h2 className="SectionTitle">Tabela: Rezerwacje.</h2>
            {reservationsLoading ? (
              <p className="Muted">Wczytywanie rezerwacji...</p>
            ) : reservationsError ? (
              <p className="Error">{reservationsError}</p>
            ) : (
              <div className="TableWrap">
                <div className="TableToolbar">
                  <label className="Field InlineField">
                    <span className="Label">Znajdź osobę</span>
                    <input
                      className="Input SearchInput"
                      placeholder="Imię, e-mail lub telefon"
                      value={searchText}
                      onChange={(event) => setSearchText(event.target.value)}
                    />
                  </label>
                  <div className="Field InlineField">
                    <button
                      className="Button Ghost SmallButton"
                      type="button"
                      onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                      disabled={safePage <= 1}
                    >
                      Poprzednia
                    </button>
                    <span className="Muted">
                      Strona {safePage} / {totalPages}
                    </span>
                    <button
                      className="Button Ghost SmallButton"
                      type="button"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                      }
                      disabled={safePage >= totalPages}
                    >
                      Następna
                    </button>
                  </div>
                </div>
                <table className="DataTable">
                  <thead>
                    <tr>
                      <th>Gość</th>
                      <th>E-mail</th>
                      <th>Telefon</th>
                      <th>Od</th>
                      <th>Do</th>
                      <th>Metoda płatności</th>
                      <th>Termin płatności</th>
                      <th>Potwierdzenie</th>
                      <th>Nr pokoju</th>
                      <th>Osoby</th>
                      <th>Suma</th>
                      <th>Pozycja do rezerwacji</th>
                      <th>Utworzono</th>
                      <th>Uwagi</th>
                      <th>Edytuj</th>
                      <th>Usuń</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredReservations.length === 0 ? (
                      <tr>
                        <td colSpan="16">Brak rezerwacji.</td>
                      </tr>
                    ) : (
                      paginatedReservations.map((item) => (
                        <tr key={item.id}>
                          <td>{item.guestName || "-"}</td>
                          <td>{item.guestEmail || "-"}</td>
                          <td>{item.guestPhone || "-"}</td>
                          <td>{formatDate(item.checkIn)}</td>
                          <td>{formatDate(item.checkOut)}</td>
                          <td>
                            {paymentMethodsById.get(item.paymentMethodId)?.name || "-"}
                            <label className="Field InlineField">
                              <input
                                type="checkbox"
                                checked={Boolean(item.paymentPaid)}
                                onChange={(event) =>
                                  handlePaymentPaidToggle(item.id, event.target.checked)
                                }
                              />
                              <span className="Label">zapłacone</span>
                            </label>
                          </td>
                          <td
                            className={`PaymentDueCell ${getDueDateClass(
                              item.depositDueDate,
                              item.paymentPaid
                            )}`}
                          >
                            {formatDate(item.depositDueDate) || "-"}
                          </td>
                          <td>
                            {item.confirmationConfirmed
                              ? `Potwierdzono ${formatDate(item.confirmationConfirmedAt)}`
                              : "Niepotwierdzona"}
                          </td>
                          <td>
                            {Array.isArray(item.roomAssignments)
                              ? item.roomAssignments
                                  .map((room) => room.roomNumber)
                                  .filter(Boolean)
                                  .join(", ")
                              : item.roomNumber || "-"}
                          </td>
                          <td>
                            {Array.isArray(item.roomAssignments)
                              ? item.roomAssignments.reduce(
                                  (sum, room) => sum + (Number(room.guestsCount) || 0),
                                  0
                                )
                              : item.guestsCount || "-"}
                          </td>
                          <td>{item.totalPricePln || "-"} PLN</td>
                          <td>{getReservationItemsLabel(item) || "-"}</td>
                          <td>{formatDate(item.createdAt)}</td>
                          <td>{item.notes || item.note || "-"}</td>
                          <td>
                            <button
                              className="Button Ghost"
                              type="button"
                              onClick={() => handleEditOpen(item)}
                            >
                              Edytuj
                            </button>
                          </td>
                          <td>
                            <button
                              className="Button Ghost DangerButton"
                              type="button"
                              onClick={() => handleDelete(item.id)}
                            >
                              Usuń
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="TableSection">
            <div className="CalendarHeader">
              <h2 className="SectionTitle">Kalendarz obłożenia</h2>
              <div className="CalendarActions">
                <button
                  className="Button Ghost"
                  type="button"
                  onClick={() => setCalendarDate((prev) => addMonths(prev, -1))}
                >
                  Poprzedni miesiąc
                </button>
                <div className="CalendarTitle">
                  {calendarDate.toLocaleString("pl-PL", {
                    month: "long",
                    year: "numeric"
                  })}
                </div>
                <button
                  className="Button Ghost"
                  type="button"
                  onClick={() => setCalendarDate((prev) => addMonths(prev, 1))}
                >
                  Następny miesiąc
                </button>
              </div>
            </div>
            <div className="TableWrap" ref={calendarWrapRef}>
              <table className="CalendarTable">
                <thead>
                  <tr>
                    <th>Pokój</th>
                    {calendarDays.map((day) => {
                      const today = new Date();
                      const isToday =
                        day.getFullYear() === today.getFullYear()
                        && day.getMonth() === today.getMonth()
                        && day.getDate() === today.getDate();
                      return (
                        <th
                          key={day.toISOString()}
                          data-today={isToday ? "true" : "false"}
                        >
                          {day.getDate()}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {allRoomNumbers.map((room) => {
                      const roomKey = String(room).trim();
                      const capacity = getRoomCapacityByNumber(roomKey);
                      return (
                        <tr key={roomKey}>
                          <td>{roomKey}</td>
                          {calendarDays.map((day) => {
                            const count = occupancyByRoom[roomKey]?.[day.getDate()] || 0;
                            const ratio = capacity ? count / capacity : 0;
                            const occupancyClass = ratio === 0
                              ? "Empty"
                              : ratio <= 0.5
                                ? "Low"
                                : ratio <= 0.8
                                  ? "Mid"
                                  : ratio < 1
                                    ? "High"
                                    : "Full";
                            return (
                              <td
                                key={day.toISOString()}
                                className={`OccupancyCell ${occupancyClass}`}
                                role="button"
                                tabIndex={0}
                                onClick={() => handleCalendarOpen(roomKey, day)}
                                onKeyDown={(event) => {
                                  if (event.key === "Enter") {
                                    handleCalendarOpen(roomKey, day);
                                  }
                                }}
                              >
                                {count}/{capacity}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      {calendarModalOpen ? (
        <div className="ModalOverlay" onClick={() => setCalendarModalOpen(false)}>
          <div className="ModalPanel" onClick={(event) => event.stopPropagation()}>
            <div className="ModalHeader">
              <h2 className="SectionTitle">Rezerwacja z kalendarza</h2>
              <button
                className="Button Ghost"
                type="button"
                onClick={() => setCalendarModalOpen(false)}
              >
                Zamknij
              </button>
            </div>
            <form className="Form" onSubmit={handleCalendarSubmit}>
              <div className="ModalGrid">



<label className="Field">
                  <span className="Label">Zameldowanie</span>
<input
  className="Input"
  type="date"
  value={modalValues.checkIn}
  onChange={(event) => {
    const newCheckIn = event.target.value;
    setModalValues((prev) => ({
      ...prev,
      checkIn: newCheckIn
    }));
  }}
  onBlur={(event) => {
    const newCheckIn = event.target.value;
// --- ADD +1 DAY HERE ---
      const nextDay = new Date(newCheckIn);
      nextDay.setDate(nextDay.getDate() + 1);
      const nextDayStr = nextDay.toISOString().split("T")[0];
      // ------------------------
    setModalValues((prev) => {
      const checkOutDate =
        prev.checkOut && new Date(prev.checkOut) >= new Date(newCheckIn)
          ? prev.checkOut
          : nextDayStr; // use +1 day

      return {
        ...prev,
        checkOut: checkOutDate
      };
    });
  }}
  required
/>

                  </label>







                {/* <label className="Field">
                  <span className="Label">Zameldowanie</span>
                  <input
                    className="Input"
                    type="date"
                    value={modalValues.checkIn}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        checkIn: event.target.value
                      }))
                    }
                    required
                  />
                </label> */}




                <label className="Field">
                  <span className="Label">Wymeldowanie</span>
                  
                  
                  
                  
<input
  className="Input"
  type="date"
  value={modalValues.checkOut}
  min={(() => {
    if (!modalValues.checkIn) return "";
    const d = new Date(modalValues.checkIn);
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  })()}
  onChange={(event) =>    
    setModalValues((prev) => ({
      ...prev,
      checkOut: event.target.value
    }))
  }
  required
/>
                  
                  
                  
                  
                  
                  
                  {/* <input
                    className="Input"
                    type="date"
                    value={modalValues.checkOut}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        checkOut: event.target.value
                      }))
                    }
                    required
                  /> */}
                </label>

                <label className="Field">
                  <span className="Label">Imię i nazwisko</span>
                  <input
                    className="Input"
                    value={modalValues.guestName}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        guestName: event.target.value
                      }))
                    }
                    required
                  />
                </label>

                <label className="Field">
                  <span className="Label">E-mail gościa</span>
                  <input
                    className="Input"
                    type="text"
                    value={modalValues.guestEmail}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        guestEmail: event.target.value
                      }))
                    }
                  />
                </label>

                <label className="Field">
                  <span className="Label">Telefon</span>
                  <input
                    className="Input"
                    value={modalValues.guestPhone}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        guestPhone: event.target.value
                      }))
                    }
                  />
                </label>

                <label className="Field">
                  <span className="Label">Metoda płatności</span>
                  <select
                    className="Input"
                    value={modalValues.paymentMethodId}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        paymentMethodId: event.target.value
                      }))
                    }
                  >
                    <option value="">Wybierz metodę</option>
                    {paymentMethods.map((method) => (
                      <option key={method.id} value={method.id}>
                        {method.name}
                      </option>
                    ))}
                  </select>
                </label>

                <label className="Field FullRow">
                  <span className="Label">Uwagi</span>
                  <textarea
                    className="Input TextArea"
                    rows="3"
                    value={modalValues.notes}
                    onChange={(event) =>
                      setModalValues((prev) => ({
                        ...prev,
                        notes: event.target.value
                      }))
                    }
                  />
                </label>
              </div>

              <div className="RoomAssignments">
                <div className="RoomHeader">
                  <span className="Label">Pokoje w rezerwacji</span>
                  <button
                    className="Button Ghost SmallButton"
                    type="button"
                    onClick={reserveAllModalRooms}
                    disabled={allRoomNumbers.length === 0}
                  >
                    Rezerwuj całość
                  </button>
                  <button
                    className="Button Ghost SmallButton"
                    type="button"
                    onClick={addModalRoom}
                  >
                    Dodaj pokój
                  </button>
                </div>
                {modalValues.roomAssignments.map((assignment, index) => {
                  const usedRooms = modalValues.roomAssignments
                    .filter((_, idx) => idx !== index)
                    .map((item) => item.roomNumber);
                  const options = allRoomNumbers.filter(
                    (room) => !usedRooms.includes(room)
                  );
                  const capacity = getRoomCapacityByNumber(assignment.roomNumber);
                  const nights = getNights(modalValues.checkIn, modalValues.checkOut);
                  const guests = Number(assignment.guestsCount) || 0;
                  const pricing = getRoomPricing(assignment);
                  const roomPrice = pricing.applyPerPerson
                    ? pricing.pricePerPerson * guests * nights
                    : pricing.pricePerDay * nights;

                  return (
                    <div key={`${assignment.roomNumber}-${index}`} className="RoomRow">
                      <label className="Field">
                        <span className="Label">Numer pokoju</span>
                        <select
                          className="Input"
                          value={assignment.roomNumber}
                          onChange={(event) =>
                            updateModalAssignment(index, {
                              roomNumber: event.target.value
                            })
                          }
                          required
                        >
                          {options.map((room) => (
                            <option key={room} value={room}>
                              {room}
                            </option>
                          ))}
                        </select>
                      </label>

                      <label className="Field">
                        <span className="Label">Liczba osób</span>
                        <input
                          className="Input"
                          type="number"
                          min="1"
                          max={String(capacity)}
                          value={assignment.guestsCount}
                          onChange={(event) =>
                            updateModalAssignment(index, {
                              guestsCount: event.target.value
                            })
                          }
                          required
                        />
                      </label>

                      <p className="Muted">
                        Koszt pokoju: {roomPrice || 0} PLN
                      </p>

                      {modalValues.roomAssignments.length > 1 ? (
                        <button
                          className="Button Ghost DangerButton SmallButton"
                          type="button"
                          onClick={() => removeModalRoom(index)}
                        >
                          Usuń pokój
                        </button>
                      ) : null}
                    </div>
                  );
                })}
              </div>

              {reservationItems.length > 0 ? (
                <div className="RoomAssignments">
                  <span className="Label">Pozycje do rezerwacji</span>
                  <div className="FormGrid">
                    {reservationItems.map((item) => {
                      const rules = getReservationItemRules(item);
                      const pricingMode = rules.applyPerPerson
                        ? "za osobę"
                        : rules.applyPerDay
                          ? "za dobę"
                          : "za sztukę";
                      const totalGuests = getTotalGuests(modalValues.roomAssignments);
                      return (
                        <label key={item.id} className="Field InlineField">
                          <span className="Label">
                            {item.name} ({rules.price} PLN, {pricingMode})
                          </span>
                          <input
                            className="Input SmallInput"
                            type="number"
                            min="0"
                            max={rules.applyPerPerson ? String(totalGuests || 0) : undefined}
                            step="1"
                            value={modalValues.reservationItemsQty?.[item.id] || ""}
                            onChange={(event) => updateModalReservationItemQty(item.id, event.target.value)}
                            placeholder="ilość"
                          />
                        </label>
                      );
                    })}
                  </div>
                </div>
              ) : null}

              <div className="SummaryRow">
                <span>
                  Liczba nocy: {getNights(modalValues.checkIn, modalValues.checkOut)}
                <br />
                <strong>
                  Suma: {getTotalPrice(
                    modalValues.roomAssignments,
                    modalValues.checkIn,
                    modalValues.checkOut,
                    modalValues.reservationItemIds,
                    modalValues.reservationItemsQty
                  )} PLN
                </strong>
                </span>
              </div>
              {modalValues.paymentMethodId ? (
                <div className="SummaryRow">
                  <span>
                    Zadatek: {getDepositInfo(
                      getTotalPrice(
                        modalValues.roomAssignments,
                        modalValues.checkIn,
                        modalValues.checkOut,
                        modalValues.reservationItemIds,
                        modalValues.reservationItemsQty
                      ),
                      modalValues.createdAt || new Date(),
                      modalValues.paymentMethodId
                    ).amount} PLN
                  <br />
                  <strong>
                    Termin: {getDepositInfo(
                      getTotalPrice(
                        modalValues.roomAssignments,
                        modalValues.checkIn,
                        modalValues.checkOut,
                        modalValues.reservationItemIds,
                        modalValues.reservationItemsQty
                      ),
                      modalValues.createdAt || new Date(),
                      modalValues.paymentMethodId
                    ).dueDate || "-"}
                  </strong>
                  </span>
                </div>
              ) : null}

              {modalShowCalendar ? (
                <div className="MiniCalendar">
                  <div className="CalendarHeader">
                    <h2 className="SectionTitle">Kalendarz obłożenia</h2>
                  </div>
                  <div className="TableWrap" ref={modalCalendarWrapRef}>
                    <table className="CalendarTable">
                      <thead>
                        <tr>
                          <th>Pokój</th>
                          {calendarDays.map((day) => {
                            const today = new Date();
                            const isToday =
                              day.getFullYear() === today.getFullYear()
                              && day.getMonth() === today.getMonth()
                              && day.getDate() === today.getDate();
                            return (
                              <th
                                key={day.toISOString()}
                                data-today={isToday ? "true" : "false"}
                              >
                                {day.getDate()}
                              </th>
                            );
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {allRoomNumbers.map((room) => {
                          const capacity = getRoomCapacityByNumber(room);
                          return (
                            <tr key={`modal-${room}`}>
                              <td>{room}</td>
                              {calendarDays.map((day) => {
                                const count = occupancyByRoom[room]?.[day.getDate()] || 0;
                                const ratio = capacity ? count / capacity : 0;
                                const occupancyClass = ratio === 0
                                  ? "Empty"
                                  : ratio <= 0.5
                                    ? "Low"
                                    : ratio <= 0.8
                                      ? "Mid"
                                      : ratio < 1
                                        ? "High"
                                        : "Full";
                                return (
                                  <td
                                    key={`${room}-${day.toISOString()}`}
                                    className={`OccupancyCell ${occupancyClass}`}
                                  >
                                    {count}/{capacity}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : null}

              {modalStatus.message ? (
                <p className={modalStatus.type === "error" ? "Error" : "Success"}>
                  {modalStatus.message}
                </p>
              ) : null}

              <button className="Button" type="submit" disabled={modalSaving}>
                {modalSaving ? "Zapisywanie..." : "Zapisz rezerwację"}
              </button>
            </form>
          </div>
        </div>
      ) : null}

      {editModalOpen ? (
        <div className="ModalOverlay" onClick={() => setEditModalOpen(false)}>
          <div className="ModalPanel" onClick={(event) => event.stopPropagation()}>
            <div className="ModalHeader">
              <h2 className="SectionTitle">Edytuj rezerwację</h2>
              <button
                className="Button Ghost"
                type="button"
                onClick={() => setEditModalOpen(false)}
              >
                Zamknij
              </button>
            </div>
            <form className="Form" onSubmit={handleEditSubmit}>
              <div className="ModalGrid">
                <label className="Field">
                  <span className="Label">Zameldowanie</span>
                  <input
                    className="Input"
                    type="date"
                    value={editValues.checkIn}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        checkIn: event.target.value
                      }))
                    }
                    required
                  />
                </label>

                <label className="Field">
                  <span className="Label">Wymeldowanie</span>
                  <input
                    className="Input"
                    type="date"
                    value={editValues.checkOut}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        checkOut: event.target.value
                      }))
                    }
                    required
                  />
                </label>

                <label className="Field">
                  <span className="Label">Imię i nazwisko</span>
                  <input
                    className="Input"
                    value={editValues.guestName}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        guestName: event.target.value
                      }))
                    }
                    required
                  />
                </label>

                <label className="Field">
                  <span className="Label">E-mail gościa</span>
                  <input
                    className="Input"
                    type="text"
                    value={editValues.guestEmail}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        guestEmail: event.target.value
                      }))
                    }
                  />
                </label>

                <label className="Field">
                  <span className="Label">Telefon</span>
                  <input
                    className="Input"
                    value={editValues.guestPhone}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        guestPhone: event.target.value
                      }))
                    }
                  />
                </label>

                <label className="Field">
                  <span className="Label">Metoda płatności</span>
                  <select
                    className="Input"
                    value={editValues.paymentMethodId}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        paymentMethodId: event.target.value
                      }))
                    }
                  >
                    <option value="">Wybierz metodę</option>
                    {paymentMethods.map((method) => (
                      <option key={method.id} value={method.id}>
                        {method.name}
                      </option>
                    ))}
                  </select>
                </label>

                <label className="Field FullRow">
                  <span className="Label">Uwagi</span>
                  <textarea
                    className="Input TextArea"
                    rows="3"
                    value={editValues.notes}
                    onChange={(event) =>
                      setEditValues((prev) => ({
                        ...prev,
                        notes: event.target.value
                      }))
                    }
                  />
                </label>
              </div>

              <div className="RoomAssignments">
                <div className="RoomHeader">
                  <span className="Label">Pokoje w rezerwacji</span>
                  <button
                    className="Button Ghost SmallButton"
                    type="button"
                    onClick={reserveAllEditRooms}
                    disabled={allRoomNumbers.length === 0}
                  >
                    Rezerwuj całość
                  </button>
                  <button
                    className="Button Ghost SmallButton"
                    type="button"
                    onClick={addEditRoom}
                  >
                    Dodaj pokój
                  </button>
                </div>
                {editValues.roomAssignments.map((assignment, index) => {
                  const usedRooms = editValues.roomAssignments
                    .filter((_, idx) => idx !== index)
                    .map((item) => item.roomNumber);
                  const options = allRoomNumbers.filter(
                    (room) => !usedRooms.includes(room)
                  );
                  const capacity = getRoomCapacityByNumber(assignment.roomNumber);
                  const nights = getNights(editValues.checkIn, editValues.checkOut);
                  const guests = Number(assignment.guestsCount) || 0;
                  const pricing = getRoomPricing(assignment);
                  const roomPrice = pricing.applyPerPerson
                    ? pricing.pricePerPerson * guests * nights
                    : pricing.pricePerDay * nights;

                  return (
                    <div key={`${assignment.roomNumber}-${index}`} className="RoomRow">
                      <label className="Field">
                        <span className="Label">Numer pokoju</span>
                        <select
                          className="Input"
                          value={assignment.roomNumber}
                          onChange={(event) =>
                            updateEditAssignment(index, {
                              roomNumber: event.target.value
                            })
                          }
                          required
                        >
                          {options.map((room) => (
                            <option key={room} value={room}>
                              {room}
                            </option>
                          ))}
                        </select>
                      </label>

                      <label className="Field">
                        <span className="Label">Liczba osób</span>
                        <input
                          className="Input"
                          type="number"
                          min="1"
                          max={String(capacity)}
                          value={assignment.guestsCount}
                          onChange={(event) =>
                            updateEditAssignment(index, {
                              guestsCount: event.target.value
                            })
                          }
                          required
                        />
                      </label>

                      <p className="Muted">
                        Koszt pokoju: {roomPrice || 0} PLN
                      </p>

                      {editValues.roomAssignments.length > 1 ? (
                        <button
                          className="Button Ghost DangerButton SmallButton"
                          type="button"
                          onClick={() => removeEditRoom(index)}
                        >
                          Usuń pokój
                        </button>
                      ) : null}
                    </div>
                  );
                })}
              </div>

              {reservationItems.length > 0 ? (
                <div className="RoomAssignments">
                  <span className="Label">Pozycje do rezerwacji</span>
                  <div className="FormGrid">
                    {reservationItems.map((item) => {
                      const rules = getReservationItemRules(item);
                      const pricingMode = rules.applyPerPerson
                        ? "za osobę"
                        : rules.applyPerDay
                          ? "za dobę"
                          : "za sztukę";
                      const checked = (editValues.reservationItemIds || []).includes(item.id);
                      const totalGuests = getTotalGuests(editValues.roomAssignments);
                      return (
                        <label key={item.id} className="Field InlineField">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => toggleEditReservationItem(item.id)}
                          />
                          <span className="Label">
                            {item.name} ({rules.price} PLN, {pricingMode})
                          </span>
                          {checked ? (
                            <input
                              className="Input SmallInput"
                              type="number"
                              min="0"
                              max={rules.applyPerPerson ? String(totalGuests || 0) : undefined}
                              step="1"
                              value={editValues.reservationItemsQty?.[item.id] || ""}
                              onChange={(event) => updateEditReservationItemQty(item.id, event.target.value)}
                              placeholder="ilość"
                            />
                          ) : null}
                        </label>
                      );
                    })}
                  </div>
                </div>
              ) : null}

              <div className="SummaryRow">
                <span>
                  Liczba nocy: {getNights(editValues.checkIn, editValues.checkOut)}
                <br />
                <strong>
                  Suma: {getTotalPrice(
                    editValues.roomAssignments,
                    editValues.checkIn,
                    editValues.checkOut,
                    editValues.reservationItemIds,
                    editValues.reservationItemsQty
                  )} PLN
                </strong>
                </span>
              </div>
              {editValues.paymentMethodId ? (
                <div className="SummaryRow">
                  <span>
                    Zadatek: {getDepositInfo(
                      getTotalPrice(
                        editValues.roomAssignments,
                        editValues.checkIn,
                        editValues.checkOut,
                        editValues.reservationItemIds,
                        editValues.reservationItemsQty
                      ),
                      editValues.createdAt || new Date(),
                      editValues.paymentMethodId
                    ).amount} PLN
                  <br />
                  <strong>
                    Termin: {getDepositInfo(
                      getTotalPrice(
                        editValues.roomAssignments,
                        editValues.checkIn,
                        editValues.checkOut,
                        editValues.reservationItemIds,
                        editValues.reservationItemsQty
                      ),
                      editValues.createdAt || new Date(),
                      editValues.paymentMethodId
                    ).dueDate || "-"}
                  </strong>
                  </span>
                </div>
              ) : null}

              {editStatus.message ? (
                <p className={editStatus.type === "error" ? "Error" : "Success"}>
                  {editStatus.message}
                </p>
              ) : null}

              <button className="Button" type="submit" disabled={editSaving}>
                {editSaving ? "Zapisywanie..." : "Zapisz zmiany"}
              </button>
            </form>
          </div>
        </div>
      ) : null}

      {infoModal.open ? (
        <div className="ModalOverlay" onClick={() => setInfoModal({ open: false, message: "" })}>
          <div className="ModalPanel InfoModal" onClick={(event) => event.stopPropagation()}>
            <div className="ModalHeader">
              <h2 className="SectionTitle">Informacja</h2>
              <button
                className="Button Ghost"
                type="button"
                onClick={() => setInfoModal({ open: false, message: "" })}
              >
                Zamknij
              </button>
            </div>
            <p className="Error">{infoModal.message}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ReservationPageAdm;
